<template>
  <v-dialog v-model="dialog.value" max-width="500">
    <template v-slot:activator="{ on: modelOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn icon v-on="{ ...modelOn, ...tooltipOn }">
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Przeglądaj jako</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar color="green" dark flat>
        <v-toolbar-title>Przeglądaj jako inny użytkownik</v-toolbar-title>
      </v-toolbar>
      <v-skeleton-loader v-if="initialTenantsLoading" class="mx-auto" type="card" />
      <template v-if="!initialTenantsLoading">
        <v-card-text v-if="!initialTenantsLoading" class="mt-4">
          <v-autocomplete
            v-if="canSearchTenants"
            v-model="selectedTenant"
            :loading="impersonation.availableTenants.loading"
            :items="impersonation.availableTenants.items"
            item-text="displayName"
            item-value="id"
            flat
            hide-no-data
            hide-details
            cache-items
            label="Wybierz tenant"
          />
          <v-scroll-y-transition>
            <v-autocomplete
              v-if="!canSearchTenants || selectedTenant !== null"
              v-model="selectedUser"
              class="mt-5"
              :loading="impersonation.availableUsers.loading"
              :items="impersonation.availableUsers.items"
              :search-input.sync="searchUsers"
              item-text="displayName"
              item-value="id"
              flat
              hide-no-data
              hide-details
              label="Wybierz użytkownika"
            />
          </v-scroll-y-transition>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn v-if="selectedUser" color="green" text :loading="dialog.loading" @click="impersonateUser"
            >Przeglądaj jako wybrany użytkownik</v-btn
          >
          <v-btn
            :color="selectedUser ? undefined : 'primary'"
            :class="{ 'text--secondary': selectedUser }"
            text
            :disabled="dialog.loading"
            @click="dialog.value = false"
            >Zamknij</v-btn
          >
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('account');

export default {
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      },
      selectedTenant: null,
      selectedUser: null,
      searchTenants: null,
      searchUsers: null,
      initialTenantsLoading: false
    };
  },
  computed: {
    ...mapState(['impersonation', 'tenant']),
    canSearchTenants() {
      return this.impersonation.availableTenants.canSearchTenants;
    },
    'dialog.loading'() {
      return this.impersonation.isImpersonated.loading;
    }
  },
  watch: {
    selectedTenant(val) {
      this.selectedUser = null;
      this.loadAvailableUsersForImpersonation({
        keyword: '',
        tenantId: val === 'null' ? null : val
      });
    },
    searchUsers(val) {
      if (this.selectedUser) {
        return;
      }

      const tenantId = this.canSearchTenants ? this.selectedTenant : null;
      this.loadAvailableUsersForImpersonation({
        keyword: val,
        tenantId: tenantId === 'null' ? null : tenantId
      });
    },
    'dialog.value'(val) {
      if (val) {
        this.resetData();
      }
    }
  },
  methods: {
    ...mapActions(['loadAvailableTenantsForImpersonation', 'loadAvailableUsersForImpersonation', 'impersonate']),
    resetData() {
      this.selectedTenant = null;
      this.selectedUser = null;

      this.initialTenantsLoading = true;
      this.loadAvailableTenantsForImpersonation({}).then(() => {
        this.initialTenantsLoading = false;
      });
    },
    async impersonateUser() {
      this.dialog.loading = true;

      const user = this.impersonation.availableUsers.items.find(user => user.id === this.selectedUser);
      await this.impersonate({
        targetUserId: this.selectedUser,
        targetTenantId: user.tenantId
      });

      try {
        await this.$router.replace('/');
        this.dialog.value = false;
        this.dialog.loading = false;
      } catch (e) {
        // can replace with same path
        this.$router.go();
      }
    }
  }
};
</script>

<style scoped></style>
